module.exports = __webpack_public_path__ + "static/media/SaintPaulsChoirSchool.0ecd7a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/SaintPaulsChoirSchool.png
// module id = 695
// module chunks = 0